import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { usePurchasedGoodsTaxonomyList } from '@shared/api/lib/purchased-goods/purchased-goods';
import {
  InsightsTaxonomyCategory,
  PurchasedGoodsTaxonomyListParams,
} from '@shared/api/types';

/**
 * The product taxonomy the insights filter can offer, nested category >
 * subcategory > base product and in the taxonomy's own order.
 *
 * Scoped by the same site, supplier, item and period params as the insights
 * request, but not by the taxonomy selection itself — the whole tree stays on
 * offer so the filter can be browsed without applying anything.
 */
export const useGetPurchasedGoodsTaxonomy = (
  params?: PurchasedGoodsTaxonomyListParams,
  options?: { enabled?: boolean }
) =>
  usePurchasedGoodsTaxonomyList<readonly InsightsTaxonomyCategory[]>(params, {
    request: useAxiosConfig(),
    query: {
      keepPreviousData: true,
      enabled: options?.enabled,
    },
  });
